import React, { useCallback, useEffect, useState } from "react";
import {
  Button,
  Divider,
  Grid,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  Box,
  Stack,
  CardContent,
} from "@mui/material";
import CustomFormLabel from "src/components/forms/theme-elements/CustomFormLabel";
import ParentCard from "src/components/shared/ParentCard";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import { useNavigate } from "react-router";
import CustomTextField from "src/components/forms/theme-elements/CustomTextField";
import { IconArrowBack } from "@tabler/icons";
import {
  Autocomplete,
  GoogleMap,
  Marker,
  Circle,
} from "@react-google-maps/api";
import { Link } from "react-router-dom";
import { CgProfile } from "react-icons/cg";
import BlankCard from "src/components/shared/BlankCard";
import VehicleDetailsService from "src/service/vehicleDetails";
import mqtt from "precompiled-mqtt";
import CustomMarker from "src/components/map/marker/CustomMarker";
import CustomInfoWindowNearby from "src/components/map/marker/CustomInfoWindow_nearby";
import carImage from "../../../../assets/images/car.png";
import moment from "moment";

const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: " Find Nearby Vehicle ",
  },
];

const NearbyVehicle = () => {
  const sessionData = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();

  // eslint-disable-next-line no-unused-vars
  const [starting_place_name, setStarting_place_name] = useState("");
  const [starting_latitude, setStarting_latitude] = useState(0);
  const [starting_longitude, setStarting_longitude] = useState(0);
  const [selectedOption, setSelectedOption] = useState("place_name");
  const [radius, setRadius] = useState(0);
  const [activeInfoWindow, setActiveInfoWindow] = useState(null);
  const [startMarker, setStartMarker] = useState({
    position: { lat: 25.612677, lng: 85.158875 },
    address: "",
  });

  const [endMarker, setEndMarker] = useState({
    position: { lat: 25.612677, lng: 85.158875 },
    address: "",
  });

  const onAutocompleteLoadStart = (autocomplete) => {
    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();

      if (place.geometry) {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();

        setStartMarker({
          position: { lat, lng },
          address: place.formatted_address,
        });

        setStarting_place_name(place.formatted_address);
        setStarting_latitude(lat);
        setStarting_longitude(lng);
      }
    });
  };

  const calculateDistance = (lat1, lng1, lat2, lng2) => {
    const toRad = (value) => (value * Math.PI) / 180;
    const R = 6371;
    const dLat = toRad(lat2 - lat1);
    const dLng = toRad(lng2 - lng1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) *
        Math.cos(toRad(lat2)) *
        Math.sin(dLng / 2) *
        Math.sin(dLng / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  };

  const calculateEndingCoordinates = (startLat, startLng, distance) => {
    const endingLat = startLat + distance / 111.32;
    const endingLng = startLng;

    return { lat: endingLat, lng: endingLng };
  };

  const handleValuesChange = () => {
    if (starting_latitude && starting_longitude && radius) {
      const endingCoordinates = calculateEndingCoordinates(
        parseFloat(starting_latitude),
        parseFloat(starting_longitude),
        parseFloat(radius)
      );
      setEndMarker({
        position: endingCoordinates,
        address: `Geofencing Area (Radius: ${radius} km)`,
      });
    }
  };

  useEffect(() => {
    if (starting_latitude && starting_longitude && radius) {
      const endingCoordinates = calculateEndingCoordinates(
        parseFloat(starting_latitude),
        parseFloat(starting_longitude),
        parseFloat(radius)
      );
      setEndMarker({
        position: endingCoordinates,
        address: `Geofencing Area (Radius: ${radius} km)`,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    handleValuesChange();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [starting_latitude, starting_longitude, radius]);

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
    setStarting_place_name("");
    setStarting_latitude(0);
    setStarting_longitude(0);
  };

  const handleLatChange = (event) => {
    const { value } = event.target;
    const lat = parseFloat(value);
    setStarting_latitude(isNaN(lat) ? "" : lat);
    setStartMarker((prev) => ({
      ...prev,
      position: { ...prev.position, lat: isNaN(lat) ? 0 : lat },
    }));
  };

  const handleLngChange = (event) => {
    const { value } = event.target;
    const lng = parseFloat(value);
    setStarting_longitude(isNaN(lng) ? "" : lng);
    setStartMarker((prev) => ({
      ...prev,
      position: { ...prev.position, lng: isNaN(lng) ? 0 : lng },
    }));
  };

  const handleRadiusChange = (event) => {
    const { value } = event.target;
    const rad = parseFloat(value);
    setRadius(isNaN(rad) ? 0 : rad);
  };

  const [vehicleData, setVehicleData] = useState([]);
  const [locationData, setLocationData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const fetchAllVehicleList = async () => {
    try {
      const res = await VehicleDetailsService.fetch_vehicle_for_nearby({
        vehicle_type: sessionData?.data?.vehicle_type,
        district_id: sessionData?.data?.district_id || "",
      });
      setVehicleData(res.data);
      setLocationData(res.data);
      // console.log('vehicle coordinates---', res.data)
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAllVehicleList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionData.data.id]);

  const filteredVehicles = locationData.filter((vehicle) => {
    const distance = calculateDistance(
      starting_latitude,
      starting_longitude,
      vehicle.restLat,
      vehicle.resLong
    );
    const numberMatch = vehicle.vehicle_no
      .toLowerCase()
      .includes(searchQuery.toLowerCase());
    return numberMatch && distance <= radius;
  });

  // -------------- mqtt starts -------------------

  const mqttUrl = process.env.REACT_APP_MQTT_URL || "";

  const handleNewMessage = useCallback((message) => {
    setLocationData((prev) => {
      return prev.map((vehicle) => {
        if (vehicle?.vehicle_no === message?.vehicle_number) {
          return {
            ...vehicle,
            restLat: parseFloat(message?.latitude),
            resLong: parseFloat(message?.longitude),
            date_time: convertToIST(message?.date_time),
          };
        }
        return vehicle;
      });
    });
  }, []);

  function convertToIST(dateTimeString) {
    const dateTime = moment(dateTimeString, "DDMMYYYY HHmmss");
    const dateTimeIST = dateTime.add(5, "hours").add(30, "minutes");
    return dateTimeIST.format("DD-MM-YYYY HH:mm:ss");
  }

  useEffect(() => {
    const client = mqtt.connect(mqttUrl);

    vehicleData.forEach((vehicle) => {
      const topic = `gps/${vehicle?.vehicle_no}/data`;
      client.subscribe(topic, (err) => {
        if (!err) {
          // console.log(`Subscribed to ${topic} topic`);
        }
      });
    });

    client.on("message", (topic, message) => {
      const parsedMessage = JSON.parse(
        new TextDecoder("utf-8").decode(message)
      );
      // console.log("Message received from broker:", parsedMessage);
      handleNewMessage(parsedMessage);
    });

    return () => {
      if (client) {
        client.end();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehicleData, handleNewMessage]);

  function isLessThanSixtyMinutes(dateTimeString) {
    const dateTime = moment(dateTimeString, "DD-MM-YYYY HH:mm:ss");
    const diffInMinutes = moment().diff(dateTime, "minutes");
    return diffInMinutes < 1440;
  }

  // -------------- mqtt ends ----------------------

  return (
    <>
      <Breadcrumb title="Nearby Vehicle" items={BCrumb} />
      <ParentCard title="" style={{ minHeight: "600px !important" }}>
        <Grid container alignItems="center">
          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Typography
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
              }}
              variant="h2"
            >
              Find Nearby Vehicle
            </Typography>
          </Grid>

          <Grid
            item
            xs={8}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                navigate("/nearbyvehicle");
              }}
            >
              <IconArrowBack width={20} />
            </Button>
          </Grid>
        </Grid>
        <Divider />

        <Grid container spacing={3} style={{ marginTop: "10px" }}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Grid item spacing={3} container lg={12} md={12} sm={12} xs={12}>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <RadioGroup
                  row
                  value={selectedOption}
                  onChange={handleOptionChange}
                >
                  <FormControlLabel
                    value="place_name"
                    control={<Radio />}
                    label="Place Name"
                  />
                  <FormControlLabel
                    value="lat_lng"
                    control={<Radio />}
                    label="Latitude & Longitude"
                  />
                </RadioGroup>
              </Grid>
              {selectedOption === "place_name" && (
                <Grid
                  item
                  lg={4}
                  md={6}
                  sm={6}
                  xs={12}
                  style={{ marginTop: "-10px" }}
                >
                  <CustomFormLabel htmlFor="place_name">
                    Start Place Name <span style={{ color: "red" }}>*</span>
                  </CustomFormLabel>
                  <Autocomplete onLoad={onAutocompleteLoadStart}>
                    <CustomTextField
                      type="text"
                      variant="outlined"
                      placeholder="Enter starting address"
                      fullWidth
                    />
                  </Autocomplete>
                </Grid>
              )}
              {selectedOption === "lat_lng" && (
                <>
                  <Grid
                    item
                    lg={4}
                    md={6}
                    sm={6}
                    xs={12}
                    style={{ marginTop: "-10px" }}
                  >
                    <CustomFormLabel htmlFor="start_pt_latitude">
                      Latitude <span style={{ color: "red" }}>*</span>
                    </CustomFormLabel>
                    <CustomTextField
                      id="start_pt_latitude"
                      name="start_pt_latitude"
                      type="number"
                      value={starting_latitude}
                      onChange={handleLatChange}
                      variant="outlined"
                      fullWidth
                    />
                  </Grid>

                  <Grid
                    item
                    lg={4}
                    md={6}
                    sm={6}
                    xs={12}
                    style={{ marginTop: "-10px" }}
                  >
                    <CustomFormLabel htmlFor="start_pt_longitude">
                      Longitude <span style={{ color: "red" }}>*</span>
                    </CustomFormLabel>
                    <CustomTextField
                      id="start_pt_longitude"
                      name="start_pt_longitude"
                      type="number"
                      value={starting_longitude}
                      onChange={handleLngChange}
                      variant="outlined"
                      fullWidth
                    />
                  </Grid>
                </>
              )}
              <Grid
                item
                lg={4}
                md={6}
                sm={6}
                xs={12}
                style={{ marginTop: "-10px" }}
              >
                <CustomFormLabel htmlFor="radius">
                  Radius (Km) <span style={{ color: "red" }}>*</span>
                </CustomFormLabel>
                <CustomTextField
                  id="radius"
                  name="radius"
                  type="text"
                  variant="outlined"
                  placeholder="Enter Radius in Km"
                  fullWidth
                  value={radius}
                  onChange={handleRadiusChange}
                />
              </Grid>
            </Grid>

            <Grid container spacing={3} style={{ marginTop: "10px" }}>
              <Grid item lg={8} md={8} sm={12} xs={12}>
                <GoogleMap
                  mapContainerStyle={{
                    height: "400px",
                    width: "100%",
                    marginTop: "20px",
                  }}
                  zoom={8}
                  center={startMarker.position}
                  onClick={() => setActiveInfoWindow(null)}
                >
                  <Marker position={startMarker.position} />

                  {endMarker.position && (
                    <Circle
                      center={startMarker.position}
                      radius={parseFloat(radius) * 1000}
                      options={{
                        strokeColor: "#73A5C6",
                        strokeOpacity: 0.8,
                        strokeWeight: 2,
                        fillColor: "#73A5C6",
                        fillOpacity: 0.35,
                      }}
                    />
                  )}
                  {filteredVehicles.map((vehicle, index) => (
                    <>
                      <CustomMarker
                        key={index}
                        position={{
                          lat: vehicle.restLat,
                          lng: vehicle.resLong,
                        }}
                        image={carImage}
                        status={
                          isLessThanSixtyMinutes(
                            convertToIST(vehicle?.date_time),
                            "minutes"
                          )
                            ? "vehicle-active"
                            : "vehicle-inactive"
                        }
                        onClick={(e) => {
                          e.stopPropagation();
                          if (activeInfoWindow === index) {
                            setActiveInfoWindow(null);
                          } else {
                            setActiveInfoWindow(index);
                          }
                        }}
                      />
                      {activeInfoWindow === index && (
                        <CustomInfoWindowNearby
                          onCloseClick={() => setActiveInfoWindow(null)}
                          vehicleInfo={vehicle}
                        />
                      )}
                    </>
                  ))}
                </GoogleMap>
              </Grid>
              <Grid item lg={4} md={4} sm={12} xs={12}>
                <BlankCard>
                  <CardContent
                    sx={{ padding: "15px" }}
                    style={{ height: "430px" }}
                  >
                    <CustomTextField
                      id="search_vehicle"
                      placeholder="Search by vehicle No or District"
                      fullWidth
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                    <Grid
                      container
                      alignItems="center"
                      style={{
                        maxHeight: "400px",
                        overflowY: "scroll",
                        paddingBottom: "70px",
                        marginTop: "20px",
                      }}
                    >
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Stack spacing={3} mt={5} sx={{ marginTop: "20px" }}>
                          {filteredVehicles.length > 0 ? (
                            filteredVehicles.map((stat, i) => (
                              <Stack
                                direction="row"
                                spacing={2}
                                justifyContent="space-between"
                                alignItems="center"
                                key={i}
                              >
                                <Stack
                                  direction="row"
                                  alignItems="center"
                                  spacing={2}
                                >
                                  <Box>
                                    <Typography
                                      variant="h6"
                                      textTransform="capitalize"
                                      lineHeight={1}
                                      style={{ fontSize: "14px" }}
                                    >
                                      {stat.vehicle_no}
                                    </Typography>
                                    <Typography
                                      variant="subtitle4"
                                      color="textSecondary"
                                    >
                                      {stat.district_name}
                                    </Typography>
                                  </Box>
                                </Stack>
                                <div className="flex justify-end gap-1">
                                  <div className="rounded-full p-2 bg-[#fff1e3] shadow-md hover:shadow-lg cursor-pointer ease-in-out duration-300">
                                    <Link
                                      to={`/vehicle/details/${stat.vehicle_no}`}
                                    >
                                      <CgProfile
                                        style={{
                                          color: "#ff9f43",
                                          fontSize: "15px",
                                          cursor: "pointer",
                                          marginBottom: "0",
                                        }}
                                      />
                                    </Link>
                                  </div>
                                </div>
                              </Stack>
                            ))
                          ) : (
                            <Typography
                              variant="h6"
                              style={{ textAlign: "center", color: "red" }}
                            >
                              No Records Found !!
                            </Typography>
                          )}
                        </Stack>
                      </Grid>
                    </Grid>
                  </CardContent>
                </BlankCard>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </ParentCard>
    </>
  );
};

export default NearbyVehicle;
